// extracted by mini-css-extract-plugin
export default {"container":"loader_container__xqfgj","logo":"loader_logo__vbdAz","spin":"loader_spin__SEFUt","pulse":"loader_pulse__M4a1a","text":"loader_text__F8J7L","fade":"loader_fade__wS4jq"};